/*
 * Note: Only developers with a seat in the Font Awesome license are allowed to add/edit/remove icons from pro-version of Font Awesome.
 * More info: https://confluence.brreg.no/pages/viewpage.action?pageId=113939494
 */

import {faFilePdf} from '@fortawesome/free-regular-svg-icons/faFilePdf';
import {faCheck} from '@fortawesome/free-solid-svg-icons/faCheck';
import {faChevronDown} from '@fortawesome/free-solid-svg-icons/faChevronDown';
import {faChevronUp} from '@fortawesome/free-solid-svg-icons/faChevronUp';

let registrationIcon;
try {
  registrationIcon = require('@fortawesome/pro-regular-svg-icons/faBallotCheck').faBallotCheck;
} catch (e) {
  registrationIcon = require('@fortawesome/free-solid-svg-icons/faTasks').faTasks;
}

let infoCircle;
try {
  infoCircle = require('@fortawesome/pro-light-svg-icons/faInfoCircle').faInfoCircle;
} catch (e) {
  infoCircle = require('@fortawesome/free-solid-svg-icons/faInfoCircle').faInfoCircle;
}

export const IconCollection = {
  registrationIcon,
  pdfIcon: faFilePdf,
  checkIcon: faCheck,
  infoCircle,
  chevUp: faChevronUp,
  chevDown: faChevronDown,
};
